<template>
    <div class="top-waypoint" v-waypoint="{ active: Global.activeWp, callback: TopWaypoint }"></div>
</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        data() {
            return {
                Global,
                activeRefresh: false
            }
        },

        mounted() {
            // console.log(this.Global.activeWp)
            // this.$nextTick(() => {this.activeRefresh = true});
        },

        methods: {

            TopWaypoint ({ el, going, direction }) {

                if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_TOP)
                    this.$emit('enterdown')
                if (going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_BOTTOM)
                    this.$emit('exitup')

            }

        }

    }

</script>